import { render } from "./PrivacyPolicyModal.vue?vue&type=template&id=7f32c5a0&scoped=true"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"

import "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=7f32c5a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f32c5a0"]])

export default __exports__